module.exports = __webpack_public_path__ + "img/product.93b76207.png";